import React, { useState, useEffect, useRef } from "react";
import ProductDetailGallery from "./ProductDetailGallery";
import GallerySwiperMobile from "./GallerySwiperMobile";
import ProductDetailLabels from "./ProductDetailLabels";
import ProductReviews from "./ProductReviews";
import SimilarProducts from "./SimilarProducts";
import ProductDetailMeta from "./ProductDetailMeta";
import ProductDetailFormat from "./ProductDetailFormat";
import ProductDetailTrust from "./ProductDetailTrust";
import ProductDetailTabs from "./ProductDetailTabs";
import ProductRatingSummary from "./ProductRatingSummary";
import ProductShare from "./ProductShare";
import ProductWishlistButton from "./ProductWishlistButton";
import ProductSizeGuide from "./ProductSizeGuide";
import ProductStickyCart from "./ProductStickyCart";
import RecentlyViewed from "./RecentlyViewed";
import { pushRecentlyViewed } from "./recentlyViewed";
import { getListReturnUrl } from "./navMemory";
import {  ActiveFiltersStructure, _ProductDetail } from "./Products";
import { useFetcher, useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";

declare global {
  interface Window {
    refreshBasket: () => void;
  }
}
interface ProductDetailProps {
    data: any;
  }
interface basketResponse{
  
    success: {
        status: boolean,
        sess: {},
        message: string
    }

}

  const initialProductState: _ProductDetail = {
    id: 0,
    name: "",
    slug: "",
    description: "",
    old_price: null,
    price: 0,
    vat: 0,
    size_table: "",
    stock_amount: 0,
    difficulty: 0,
    parameters: {
      difficulty:[1,2,3],
      for_whom: [
        {
          id: 0,
          name: "",
          type: "",
          image: null,
        },
      ],
      manufacturer: [
        {
          id: 0,
          name: "",
          type: "",
          image: null,
        },
      ],
      category: [
        {
          id: 0,
          type: "",
          image: null,
          name: ""
        },
      ],
      size:[{
        id:0,
        name:"",
        type:"",
        image:null
      }]
    },
    thumbnail: "",
    images: [
      {
        id: 0,
        file: "",
        type: "",
      },
    ],
    related: [
      {
        id: 0,
        title: "",
        difficulty: 0,
        old_price: null,
        price: 0,
        vat: 0,
        slug: "",
        thumbnail: "",
      },
    ],
    variants: [
      {
        id: 0,
        type: "",
        language: "",
        size: null,
        files: null,
        price: 0,
        vat: 0,
        stock_amount: 0,
      },
    ],
  };

  const ProductDetailTest: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [productDetailData,setProductDetailData] = useState<_ProductDetail>();
    const [productItem, setproductItem] = useState({productID: 0,active: ""});
    const navigate = useNavigate();
    const location = useLocation(); 

    useEffect(()=>{
        setProductDetailData(undefined);
        const fetchProductDetailData = (slug: string) => {
      
          fetch(`/api/products/${slug}`)
              .then((res) => res.json())
              .then((productDetailData) => {
               console.log("Fetch");
                  console.log(productDetailData.data);
               
                const product: _ProductDetail = productDetailData.data;
                 product.images = Object.values(product.images).filter((img)=>Object.keys(img).length>0);
               
                   setProductDetailData(product);
                    setproductItem((prev)=>({productID: productDetailData.data.id, active: "active"}));
                    if (product?.id) pushRecentlyViewed(product.id);
                console.log("Setting document title");
                 document.title =  productDetailData.data.name+  " | " + "TiskStřihů";
              })
              .catch((error) => {
                  console.log(error.message);
              });
        }
      
        if(slug!==""){
        fetchProductDetailData(slug == undefined ? "" : slug);
        }
      },[slug]);

      async function handlerAddToCart(id: number, itemCount: number, idVariant: number): Promise<{status: boolean, message: string}> {
        console.log("variant to sent in basket ",idVariant);
        return await postCartData();

        async function postCartData(): Promise<{status: boolean, message: string}> {
            try {
                const response = await fetch("/api/cart", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        product_id: id,
                        amount: itemCount,
                        product_id_variant: idVariant
                    })
                });

                const success: basketResponse = await response.json();
                console.log(success);

                if (success.success.status && typeof window.refreshBasket === 'function') {
                    window.refreshBasket();
                }

                return { status: success.success.status, message: success.success.message };
            } catch (error) {
                console.error('Error adding to cart:', error);
                return { status: false, message: 'Chyba při komunikaci se serverem.' };
            }
        }
    }
    /*
    function handlerAddToCart (id: number, itemCount: number, idVariant: number): boolean
    {
        postCartData();
        async function postCartData() {
          const response = await fetch("/api/cart", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
                  product_id: id,
                  amount: itemCount,
                  product_id_variant: idVariant
              })
          });
          const success: basketResponse = await response.json();
          console.log(success)
           console.log("SUCCESS: " + success.success.status + ", SUCCESS MESSAGE: " + success.success.message);
           //window.location.href = "/product";
            window.refreshBasket();

          return success.success.status;
        }
     
        
          //console.log("help");
          
          //window.refreshBasket();
         
          }
*/
  

          function handlerSimilarProduct(slug: string) {
            window.scrollTo(0, 0);
            navigate(`/product/${slug}`);
          }

          const handlerClose = () => {
            document.title = "TiskStřihů";
            navigate(getListReturnUrl());
          }

          function handleCloseAndRewrite(): void {
            console.log("_________________________________________________");
            document.title = "TiskStřihů";
            if(location.state?.from==="main")
            {
              //navigate(-1);
            }else{
              //navigate("/product");
            }
            //navigate(-1);
        }
      const handleProductItem = (slug: string) => {
        //console.log("nodeiadoqwaedjaioneagrúuoejswarhngbewoarihnbgoid");
        //setProductDetailData(undefined);
        //navigate(`/product/${slug}`);
       }

       function handleParams(): void {
        throw new Error('Function not implemented.');
      }

      const detailLabelsCategoryCallback = (categoryId : number) =>{
        console.log(categoryId);
      }

    
      

    const ctaWatchRef = useRef<HTMLDivElement>(null);
    const onStickyAddToCart = () => {
        // scroll na původní CTA — uživatel uvidí variant selektor + uvědomí si volbu
        ctaWatchRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    return (
        <>
       {productDetailData ? (
        <div className="layer full active">
                <div className="box">
                    <div className="over">
                        <div className="bg">
                            <div className="detail">

                                <div className="col55">
                                    <div className="inner desktop">
                                        <ProductDetailGallery pDetailData={productDetailData} />
                                    </div>
                                    <GallerySwiperMobile pDetailData={productDetailData} />
                                </div>

                                <div className="col45">
                                    {/* Pořadí dle návrhu: drobečky → název → výrobce → spec →
                                        cena → košík (vše v Labels), pak tagy a doplňkové prvky. */}
                                    <div ref={ctaWatchRef}>
                                    <ProductDetailLabels
                                        pDetailData={productDetailData}
                                        handlerAddToCart={handlerAddToCart}
                                        handlerClose={handlerClose}
                                        handleParams={handleParams}
                                        detailLabelsCategoryCallback={detailLabelsCategoryCallback}
                                    />
                                    </div>
                                    <ProductDetailMeta pDetailData={productDetailData} />
                                    <ProductDetailFormat pDetailData={productDetailData} />
                                    <div className="pd-actions-row">
                                        <ProductWishlistButton
                                            productId={productDetailData.id}
                                            productTitle={productDetailData.name}
                                        />
                                        <ProductSizeGuide />
                                        <ProductShare title={productDetailData.name} />
                                    </div>
                                    {(productDetailData as any).rating_count ? (
                                        <div className="pd-rating-row">
                                            <ProductRatingSummary
                                                ratingAvg={(productDetailData as any).rating_avg}
                                                ratingCount={(productDetailData as any).rating_count}
                                            />
                                        </div>
                                    ) : null}
                                    <ProductDetailTrust
                                        stockAmount={productDetailData.stock_amount}
                                        hasDigital={(productDetailData.variants || []).some((v: any) => v.type === 'digital')}
                                    />
                                </div>

                            </div>

                            <ProductDetailTabs pDetailData={productDetailData} />

                            <SimilarProducts
                                pDetailData={productDetailData}
                                handleProductItem={handleProductItem}
                                handlerClose={handlerClose}
                                handlerSimilarProduct={handlerSimilarProduct}
                            />
                            <RecentlyViewed excludeId={productDetailData.id} />
                        </div>
                    </div>
                </div>
                <ProductStickyCart
                    price={(productDetailData as any).effective_price || productDetailData.price}
                    productName={productDetailData.name}
                    inStock={productDetailData.stock_amount !== 0}
                    watchRef={ctaWatchRef}
                    onAddToCart={onStickyAddToCart}
                />
        </div>
       ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '120px 20px' }}>
          <div className="spinner" aria-hidden="true" />
          <div style={{ marginTop: 18, color: '#5f6368', fontSize: 14 }}>Načítám detail produktu…</div>
        </div>
       )}
        </>
    )
    
}

export default ProductDetailTest;